import { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { IconButton } from '@/components/ui/primitives';
import { cn } from '@/lib/cn';

/** Keyed by asset so every newly selected twin starts with its notes folded away. */
export function AssetDescription({ subtitle, note }: { subtitle?: string | null; note?: string }) {
  const [open, setOpen] = useState(false);
  if (!subtitle && !note) return null;
  return (
    <>
      <IconButton
        label={open ? 'Hide model details' : 'Show model details'}
        aria-expanded={open}
        aria-controls="twin-model-details"
        className="ml-auto h-7 w-7 shrink-0"
        onClick={() => setOpen(!open)}
      >
        <ChevronDown className={cn('h-4 w-4 transition-transform', open && 'rotate-180')} />
      </IconButton>
      <div
        id="twin-model-details"
        hidden={!open}
        className="basis-full space-y-1 border-t border-hairline pt-2 text-[11px] leading-relaxed text-ink-3"
      >
        {subtitle && <p>{subtitle}</p>}
        {note && <p>{note}</p>}
      </div>
    </>
  );
}
